module.exports = __webpack_public_path__ + "static/media/button-dislike.3cdd3f6b.svg";